import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const WebcamVideo: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.89286 3.125C2.52345 3.125 2.16917 3.27175 1.90796 3.53296C1.64675 3.79417 1.5 4.14845 1.5 4.51786V11.4821C1.5 11.8515 1.64675 12.2059 1.90796 12.4671C2.16917 12.7283 2.52344 12.875 2.89286 12.875H9.85714C10.2266 12.875 10.5808 12.7283 10.8421 12.4671C11.1033 12.2059 11.25 11.8515 11.25 11.4821V10.5708L13.2162 11.4423C13.223 11.4454 13.2301 11.4482 13.2371 11.451C13.8577 11.6905 14.5 11.196 14.5 10.5814V5.41857C14.5 4.81446 13.8764 4.26072 13.2148 4.55828L13.2131 4.55906L11.25 5.4292V4.51786C11.25 4.14844 11.1033 3.79417 10.8421 3.53296C10.5808 3.27175 10.2266 3.125 9.85714 3.125H2.89286Z"
      fill="currentColor"
    />
  </svg>
);
